export default [
  {
    name: "Interaktivität",
    properties: [
      {
        name: "Cursor",
        value: "cursor",
        type: "text",
        autocomplete: ['auto', 'default', 'none', 'context-menu', 'help', 'pointer', 'progress', 'wait', 'cell', 'crosshair', 'text', 'vertical-text', 'alias', 'copy', 'move', 'no-drop', 'not-allowed', 'e-resize', 'n-resize', 'ne-resize', 'nw-resize', 's-resize', 'se-resize', 'sw-resize', 'w-resize', 'ew-resize', 'ns-resize', 'nesw-resize', 'nwse-resize', 'col-resize', 'row-resize', 'all-scroll', 'zoom-in', 'zoom-out', 'grab', 'grabbing'],
      },
      {
        name: "Pointer Events",
        value: "pointer-events",
        type: "text",
        autocomplete: ['auto', 'none', 'visiblePainted', 'visibleFill', 'visibleStroke', 'visible', 'painted', 'fill', 'stroke', 'all', 'inherit'],
      },
      {
        name: "Caret Color",
        value: "caret-color",
        type: "color",
      },
      {
        name: "User Select",
        value: "user-select",
        type: "text",
        autocomplete: ['auto', 'none', 'text', 'all'],
      },
      {
        name: "Resize",
        value: "resize",
        type: "text",
        autocomplete: ['none', 'both', 'horizontal', 'vertical'],
      },
      {
        name: "Appearance",
        value: "appearance",
        type: "text",
      },
    ]
  },
  {
    name: "Aussehen und Verhalten vom Scrollen",
    properties: [
      {
        name: "Scrollbar Color",
        value: "scrollbar-color",
        type: "color",
      },
      {
        name: "Scrollbar Width",
        value: "scrollbar-width",
        type: "text",
        autocomplete: ['auto', 'thin', 'none'],
      },
      {
        name: "Scroll Behaviour",
        value: "overscroll-behaviour",
        type: "text",
        autocomplete: ['auto', 'smooth'],
      },
      {
        name: "Snap Type",
        value: "scroll-snap-type",
        type: "text",
        autocomplete: ['none', 'x', 'y', 'block', 'inline', 'both','mandatory', 'proximity'],
      },
      {
        name: "Snap Align",
        value: "scroll-snap-align",
        type: "text",
        autocomplete: ['none', 'start', 'end', 'center'],
      },
      {
        name: "Overscroll Behaviour",
        value: "overscroll-behaviour",
        type: "text",
      },
      {
        name: "Overscroll-X Behaviour",
        value: "overscroll-behaviour-x",
        type: "text",
        autocomplete: ['contain', 'none', 'auto'],
        shorthand: 'overscroll-behaviour',
      },
      {
        name: "Overscroll-Y Behaviour",
        value: "overscroll-behaviour-y",
        type: "text",
        autocomplete: ['contain', 'none', 'auto'],
        shorthand: 'overscroll-behaviour',
      },
      {
        name: "Overscroll Block Behaviour",
        value: "overscroll-behaviour-block",
        type: "text",
        autocomplete: ['contain', 'none', 'auto'],
      },
      {
        name: "Overscroll Inline Behaviour",
        value: "overscroll-behaviour-inline",
        type: "text",
        autocomplete: ['contain', 'none', 'auto'],
      },
      {
        name: "Scroll Margin",
        value: "scrollbar-margin",
        type: "length",
      },
      {
        name: "Scroll Top Margin",
        value: "scrollbar-margin-top",
        type: "length",
        shorthand: "scroll-margin",
      },
      {
        name: "Scroll Right Margin",
        value: "scrollbar-margin-right",
        type: "length",
        shorthand: "scroll-margin",
      },
      {
        name: "Scroll Bottom Margin",
        value: "scrollbar-margin-bottom",
        type: "length",
        shorthand: "scroll-margin",
      },
      {
        name: "Scroll Left Margin",
        value: "scrollbar-margin-left",
        type: "length",
        shorthand: "scroll-margin",
      },
      {
        name: "Scroll Padding",
        value: "scrollbar-padding",
        type: "length",
      },
      {
        name: "Scroll Top Padding",
        value: "scrollbar-padding-top",
        type: "length",
        shorthand: "scroll-padding",
      },
      {
        name: "Scroll Right Padding",
        value: "scrollbar-padding-right",
        type: "length",
        shorthand: "scroll-padding",
      },
      {
        name: "Scroll Bottom Padding",
        value: "scrollbar-padding-bottom",
        type: "length",
        shorthand: "scroll-padding",
      },
      {
        name: "Scroll Left Padding",
        value: "scrollbar-padding-left",
        type: "length",
        shorthand: "scroll-padding",
      },
    ]
  },
  {
    name: "Logical Scroll Properties",
    properties: [
      {
        name: "Scroll Block Margin",
        value: "scrollbar-margin-block",
        type: "length",
      },
      {
        name: "Scroll Block Start Margin",
        value: "scrollbar-margin-block-start",
        type: "length",
        shorthand: "scroll-margin-block",
      },
      {
        name: "Scroll Block End Margin",
        value: "scrollbar-margin-block-end",
        type: "length",
        shorthand: "scroll-margin-block",
      },
      {
        name: "Scroll Inline Margin",
        value: "scrollbar-margin-inline",
        type: "length",
      },
      {
        name: "Scroll Inline Start Margin",
        value: "scrollbar-margin-inline-start",
        type: "length",
        shorthand: "scroll-margin-inline",
      },
      {
        name: "Scroll Inline End Margin",
        value: "scrollbar-margin-inline-end",
        type: "length",
        shorthand: "scroll-margin-inline",
      },
      {
        name: "Scroll Block Padding",
        value: "scrollbar-padding-block",
        type: "length",
      },
      {
        name: "Scroll Block Start Padding",
        value: "scrollbar-padding-block-start",
        type: "length",
        shorthand: "scroll-padding-block",
      },
      {
        name: "Scroll Block End Padding",
        value: "scrollbar-padding-block-end",
        type: "length",
        shorthand: "scroll-padding-block",
      },
      {
        name: "Scroll Inline Padding",
        value: "scrollbar-padding-inline",
        type: "length",
      },
      {
        name: "Scroll Inline Start Padding",
        value: "scrollbar-padding-inline-start",
        type: "length",
        shorthand: "scroll-padding-inline",
      },
      {
        name: "Scroll Inline End Padding",
        value: "scrollbar-padding-inline-end",
        type: "length",
        shorthand: "scroll-padding-inline",
      },
    ]
  },
]